import { Typography } from '@material-ui/core'
import React from 'react'

import { Metadata } from '../../../types/walletReferences'
import useStyles from './styles/ReferenceRow'

interface MetaDataRowProps {
  metadata: Metadata
  //   showMetaData: boolean
  //   setshowMetaData: React.Dispatch<React.SetStateAction<boolean>>
}

const MetaDataRow: React.FC<MetaDataRowProps> = ({
  metadata
  //   setshowMetaData,
  //   showMetaData
}) => {
  const classes = useStyles()

  return (
    <div className={classes.metadataContainer}>
      <div className={classes.metadatakey}>
        <Typography variant="body1">{metadata.key + ': '}</Typography>
      </div>
      <div>
        <Typography variant="body1">{metadata.value}</Typography>
      </div>
    </div>
  )
}
export default MetaDataRow
